import ic_purchase from "../img/purchase.svg";
import ic_inventory from "../img/inventory.svg";
import ic_invoice from "../img/invoice.svg";
import ic_marketing from "../img/marketing.svg";
import ic_project from "../img/project.svg";
import ic_receipt from "../img/receipt.svg";
import masterImg from "../img/master2.svg";
import financeIcon from "../img/finance.svg";
import taskIcon from "../img/taskIcon.svg";
import dashboardIcon from "../img/dashboard.svg";
import ic_sales_order_submodule from "../img/ic_sales_order_submodule.svg";

import ic_delivery_notes_submodule from "../img/ic_delivery_notes_submodule.svg";

import ic_invoices_submodule from "../img/ic_invoices_submodule.svg";

import ic_quotations_proposals_submodule from "../img/ic_quotations_proposals_submodule.svg";

import ic_Jobs_submodule from "../img/ic_Jobs_submodule.svg";

import ic_Vouchers_submodule from "../img/ic_Vouchers_submodule.svg";

import ic_lead_entry_submodule from "../img/ic_lead_entry_submodule.svg";

import ic_item_master_submodule from "../img/ic_item_master_submodule.svg";

import view_sales_order_list from "../img/view_sales_order_list.svg";
import create_sales_order from "../img/create_sales_order.svg";
import create_delivery_order from "../img/create_delivery_order.svg";
import create_invoice from "../img/create_invoice.svg";

import create_item from "../img/create_item.svg";
import job from "../img/job.svg";

import statements from "../img/statement.svg";

import create_receipt from "../img/create_receipt.svg";
import garageIcon from "../img/garage.svg";
// import realEstateIcon from "../img/realEstate.svg";
import realEstateIcon from "../img/reaslEstate2.svg";

const menu_list = [
  //jinu

  {
    menu_id: "Create Item",
    url_path: "/stockList",
    image: create_item,
  },
  {
    menu_id: "View_Leads",
    url_path: "/leads",
    image: view_sales_order_list,
  },
  {
    menu_id: "View_Qualified_Leads",
    url_path: "/qualifiedLeadsTable",
    image: view_sales_order_list,
  },

  {
    menu_id: "View_Lead_Quotation_List",
    url_path: "/quotationsListViewFull",
    image: view_sales_order_list,
  },
  {
    menu_id: "View_Lead_Quotation_List_Details",
    url_path: "/quoteLead",
    image: view_sales_order_list,
  },
  {
    menu_id: "Sales_Analysis_Report",
    url_path: "/sales_analysis_report",
    image: view_sales_order_list,
  },
  {
    menu_id: "Purchase_Analysis_Report",
    url_path: "/purchase_analysis_report",
    image: view_sales_order_list,
  },
  {
    menu_id: "Invoice_Profit_Analysis",
    url_path: "/invoice_profit_analysis_report",
    image: view_sales_order_list,
  },

  {
    menu_id: "Create_New_Lead_Quotation",
    url_path: "/quoteLead",
    image: view_sales_order_list,
  },

  {
    menu_id: "Sales_Order_List_CRM",
    url_path: "/salesOrderListViewFull",
    image: view_sales_order_list,
  },
  {
    menu_id: "Sample_Request",
    url_path: "/sampleRequestListViewFull",
    image: view_sales_order_list,
  },
  {
    menu_id: "Work_Order_Approval",
    url_path: "/workOrderListViewFull",
    image: view_sales_order_list,
  },
  {
    menu_id: "Work_Order_List",
    url_path: "/work_order_list",
    image: view_sales_order_list,
  },
  {
    menu_id: "Sales_Dashboard",
    url_path: "/salesDashboard",
    image: view_sales_order_list,
  },
  {
    menu_id: "E_Invoicing_Dashboard",
    url_path: "/einvoicing",
    image: view_sales_order_list,
  },
  {
    menu_id: "Finance_Dashboard",
    url_path: "/financeMainDashboard",
    image: view_sales_order_list,
  },

  // athul
  {
    menu_id: "Create_Sales_Invoice",
    url_path: "/sales_invoice",
    image: create_invoice,
  },
  {
    menu_id: "View_Sales_Invoice",
    url_path: "/invoice_list",
    image: view_sales_order_list,
  },
  {
    menu_id: "Delivery_Order_List",
    url_path: "/document_list",
    image: view_sales_order_list,
  },
  {
    menu_id: "Create_Delivery_Order",
    url_path: "/delivery_order",
    image: create_delivery_order,
  },
  {
    menu_id: "Create_Sales_Order",
    url_path: "/sales_order",
    image: create_sales_order,
  },
  {
    menu_id: "View_Sales_Order",
    url_path: "/sales_order_list",
    image: view_sales_order_list,
  },
  {
    menu_id: "Create_Sales_Quotation",
    url_path: "/quotation_entry",
    image: create_sales_order,
  },
  {
    menu_id: "View_Sales_Quotation_List",
    url_path: "/quotationList",
    image: view_sales_order_list,
  },

  {
    menu_id: "Create_Purchase_Invoice",
    url_path: "/purchase_invoice",
    image: view_sales_order_list,
  },
  {
    menu_id: "View_Purchase_Invoice_List",
    url_path: "/purchaseInvoiceList",
    image: view_sales_order_list,
  },
  {
    menu_id: "Create_Purchase_Return",
    url_path: "/purchase_return",
    image: view_sales_order_list,
  },
  {
    menu_id: "View_Purchase_Return_List",
    url_path: "/purchase_return_list",
    image: view_sales_order_list,
  },
  {
    menu_id: "Stock_List",
    url_path: "/stock-list",
    image: view_sales_order_list,
  },
  {
    menu_id: "Stock_Upload",
    url_path: "/stock_upload",
    image: view_sales_order_list,
  },
  {
    menu_id: "Physical_Stock_View",
    url_path: "/physical_stock_view",
    image: view_sales_order_list,
  },
  {
    menu_id: "Create_Physical_Stock",
    url_path: "/physical_stock_entry",
    image: view_sales_order_list,
  },
  {
    menu_id: "Create_Purchase_Order",
    url_path: "/purchase_order",
    image: view_sales_order_list,
  },
  {
    menu_id: "View_Purchase_Order_List",
    url_path: "/purchase_order_list",
    image: view_sales_order_list,
  }, {
    menu_id: "Create_Purchase_Enquiry",
    url_path: "/purchase_enquiry",
    image: view_sales_order_list,
  },
  {
    menu_id: "View_Purchase_Enquiry_List",
    url_path: "/purchase_enquiry_list",
    image: view_sales_order_list,
  },
  {
    menu_id: "Production_Dashboard",
    url_path: "/production_dashboard",
    image: view_sales_order_list,
  },
  {
    menu_id: "Distribution_Dashboard",
    url_path: "/distribution_dashboard",
    image: view_sales_order_list,
  },
  {
    menu_id: "Production",
    url_path: "/production",
    image: view_sales_order_list,
  },
  {
    menu_id: "Contract_Dashboard",
    url_path: "/contract_dashboard",
    image: view_sales_order_list,
  },

  // faizan

  {
    menu_id: "View_jobs",
    url_path: "/jobs",
    image: job,
  },
  {
    menu_id: "View_Statements",
    url_path: "/statements",
    image: statements,
  },
  {
    menu_id: "Create_Receipt",
    url_path: "/reciept",
    image: create_receipt,
  },
  {
    menu_id: "View_Receipt",
    url_path: "/recieptView",
    image: view_sales_order_list,
  },
  {
    menu_id: "Create Payment",
    url_path: "/payment",
    image: create_invoice,
  },
  {
    menu_id: "View Payment",
    url_path: "/paymentView",
    image: view_sales_order_list,
  },
  {
    menu_id: "Create_Job",
    url_path: "/newJobForm",
  },
  {
    menu_id: "Create Voucher",
    url_path: "/voucher",
    image: create_invoice,
  },
  {
    menu_id: "View Voucher List",
    url_path: "/voucherView",
    image: view_sales_order_list,
  },
  {
    menu_id: "Trial_Balance_Report",
    url_path: "/trial_balance_report",
    image: view_sales_order_list,
  },
  {
    menu_id: "Balance_Sheet_Report",
    url_path: "/balance_sheet_report",
    image: view_sales_order_list,
  },
  {
    menu_id: "Profit_And_Loss_Report",
    url_path: "/profit_and_loss_report",
    image: view_sales_order_list,
  },

  {
    menu_id: "PDC",
    url_path: "/pdc",
    image: view_sales_order_list,
  },

  {
    menu_id: "Business_Partners",
    url_path: "/businessPartners",
    image: view_sales_order_list,
  },
  {
    menu_id: "Sales_Return_List",
    url_path: "/salesreturnList",
    image: view_sales_order_list,
  },
  {
    menu_id: "Sales_Return",
    url_path: "/sales_return",
    image: view_sales_order_list,
  },

  {
    menu_id: "Voucher_Analysis_Report",
    url_path: "/voucherAnalysis",
    image: view_sales_order_list,
  },

  {
    menu_id: "Petty_Cash_Voucher",
    url_path: "/pettyCash",
    image: view_sales_order_list,
  },

  {
    menu_id: "Petty_Cash_Voucher_List",
    url_path: "/pettyCashView",
    image: view_sales_order_list,
  },

  {
    menu_id: "Item_Creation",
    url_path: "/itemCreation",
    image: view_sales_order_list,
  },
  {
    menu_id: "Salesperson_Creation",
    url_path: "/salespersonCreation",
    image: view_sales_order_list,
  },
  {
    menu_id: "Coordinator_Creation",
    url_path: "/coordinatorCreation",
    image: view_sales_order_list,
  },
  {
    menu_id: "Finance_Approval",
    url_path: "/financeApprovalDashboard",
    image: view_sales_order_list,
  },

  {
    menu_id: "Sample_Issue",
    url_path: "/sample_issue",
    image: view_sales_order_list,
  },
  {
    menu_id: "Sample_Issue_List",
    url_path: "/sample_issue_list",
    image: view_sales_order_list,
  },
  {
    menu_id: "Sample_Return",
    url_path: "/sample_return",
    image: view_sales_order_list,
  },
  {
    menu_id: "Sample_Return_List",
    url_path: "/sample_return_list",
    image: view_sales_order_list,
  },

  {
    menu_id: "Stock_Report",
    url_path: "/stock_report",
    image: view_sales_order_list,
  },
  {
    menu_id: "Vat_Report",
    url_path: "/vat_report",
    image: view_sales_order_list,
  },
  {
    menu_id: "Stock_Ledger_Report",
    url_path: "/stockLedger",
    image: view_sales_order_list,
  },
  {
    menu_id: "Delivery_Order_Report",
    url_path: "/deliveryOrderReports",
    image: view_sales_order_list,
  },
  {
    menu_id: "Sales_Order_Report",
    url_path: "/salesOrderReports",
    image: view_sales_order_list,
  },
  {
    menu_id: "Location_Transfer",
    url_path: "/location_transfer",
    image: view_sales_order_list,
  },
  {
    menu_id: "Location_Transfer_List",
    url_path: "/location_transfer_list",
    image: view_sales_order_list,
  },
  {
    menu_id: "Goods_In_Transit_List",
    url_path: "/goods_in_transit_list",
    image: view_sales_order_list,
  },
  {
    menu_id: "Goods_In_Transit",
    url_path: "/goods_in_transit",
    image: view_sales_order_list,
  },
  {
    menu_id: "Warranty_Claim_List",
    url_path: "/warranty_claim_list",
    image: view_sales_order_list,
  },
  {
    menu_id: "Warranty_Claim",
    url_path: "/warranty_claim",
    image: view_sales_order_list,
  },
  {
    menu_id: "Stock_Transfer_In",
    url_path: "/stock_transfer_in",
    image: view_sales_order_list,
  },
  {
    menu_id: "Stock_Transfer_In_List",
    url_path: "/stock_transfer_in_list",
    image: view_sales_order_list,
  },
  {
    menu_id: "Stock_Transfer_Out",
    url_path: "/stock_transfer_out",
    image: view_sales_order_list,
  },
  {
    menu_id: "Stock_Transfer_Out_List",
    url_path: "/stock_transfer_out_list",
    image: view_sales_order_list,
  },
  {
    menu_id: "Branch_Transfer_Out",
    url_path: "/branch_transfer",
    image: view_sales_order_list,
  },
  {
    menu_id: "Branch_Transfer_Out_List",
    url_path: "/branch_transfer_list",
    image: view_sales_order_list,
  },
  {
    menu_id: "Branch_Transfer_In_List",
    url_path: "/branch_transfer_in_list",
    image: view_sales_order_list,
  }, {
    menu_id: "Branch_Transfer_In",
    url_path: "/branch_transfer_in",
    image: view_sales_order_list,
  },
  {
    menu_id: "Sunrise_Job_Form",
    url_path: "/job_form",
    image: view_sales_order_list,
  },
  {
    menu_id: "Bank_Reconciliation",
    url_path: "/bankReconciliation",
    image: view_sales_order_list,
  },
  {
    menu_id: "Financial_Analysis_Report",
    url_path: "/financialAnalysisReport",
    image: view_sales_order_list,
  },
  {
    menu_id: "Bill_Allocation",
    url_path: "/billAllocation",
    image: view_sales_order_list,
  },
  {
    menu_id: "Bill_Allocation_Multiple",
    url_path: "/billAllocationMultiple",
    image: view_sales_order_list,
  },
  {
    menu_id: "G_L_Creation",
    url_path: "/customer_control/g_and_l_management",
    image: view_sales_order_list,
  },
  {
    menu_id: "Budget_Allocation",
    url_path: "/budget_allocation",
    image: view_sales_order_list,
  },
  {
    menu_id: "Budget_Analysis",
    url_path: "/budget_analysis",
    image: view_sales_order_list,
  },
  {
    menu_id: "Register_Asset",
    url_path: "/register_asset",
    image: view_sales_order_list,
  },
  {
    menu_id: "Asset_Register_List",
    url_path: "/asset_register_list",
    image: view_sales_order_list,
  },
  {
    menu_id: "Projects_Dashboard",
    url_path: "/projectsDashboard",
    image: view_sales_order_list,
  },
  {
    menu_id: "Price_Manager",
    url_path: "/price_manager",
    image: view_sales_order_list,
  },
  {
    menu_id: "Price_Updater",
    url_path: "/price_updater",
    image: view_sales_order_list,
  },
  {
    menu_id: "Quotation_Reports",
    url_path: "/quotation_report",
    image: view_sales_order_list,
  },
  // Real Estate modules 
    {
    menu_id: "Building_Register",
    url_path: "/buildingRegister",
    image: view_sales_order_list,
  },
    {
    menu_id: "Tenancy_Contract_Register",
    url_path: "/tenancyContractRegister",
    image: view_sales_order_list,
  },
  {
    menu_id: "Tenancy_Contract_List",
    url_path: "/tenancyContractList",
    image: view_sales_order_list,
  },
    {
    menu_id: "Rental_Unit_Dashboard",
    url_path: "/rentalUnitDashboard",
    image: view_sales_order_list,
  },
    {
    menu_id: "Tenant_Register",
    url_path: "/tenantRegister",
    image: view_sales_order_list,
  },
    {
    menu_id: "Tenant_Creation",
    url_path: "/tenantCreation",
    image: view_sales_order_list,
  },
    {
    menu_id: "Contract_Analysis",
    url_path: "/contractAnalysis",
    image: view_sales_order_list,
  },
    {
    menu_id: "Property_Inspection",
    url_path: "/rsInspection",
    image: view_sales_order_list,
  },
    {
    menu_id: "Dashboard",
    url_path: "/rsDashboard",
    image: view_sales_order_list,
  },
    {
    menu_id: "Receipt",
    // url_path: "/rsrv",
    url_path: "/receiptRealEstate",
    image: view_sales_order_list,
  },
  // Real Estate modules 
];

const module_list = [
  {
    module_id: "PURCHASE",
    image: ic_purchase,
  },
  {
    module_id: "INVENTORY",
    image: ic_inventory,
  },
  {
    module_id: "SALES",
    image: ic_invoice,
  },
  {
    module_id: "MARKETING",
    image: ic_marketing,
  },
  {
    module_id: "PROJECTS",
    image: taskIcon,
  },
  {
    module_id: "FINANCE",
    image: financeIcon,
  },
  {
    module_id: "MASTER",
    image: masterImg,
  },
  {
    module_id: "Dashboards",
    image: dashboardIcon,
  },
    {
    module_id: "GARAGE",
    image: garageIcon,
  },
    {
    module_id: "Real Estate",
    image: realEstateIcon,
  },
];

const sub_module_list = [
  {
    sub_module_id: "sales-orders",
    image: ic_sales_order_submodule,
  },
  {
    sub_module_id: "delivery-notes",
    image: ic_delivery_notes_submodule,
  },
  {
    sub_module_id: "invoices",
    image: ic_invoices_submodule,
  },
  {
    sub_module_id: "quotations-proposals",
    image: ic_quotations_proposals_submodule,
  },
  {
    sub_module_id: "task_managemen",
    image: ic_Jobs_submodule,
  },
  {
    sub_module_id: "Vouchers",
    image: ic_Vouchers_submodule,
  },
  {
    sub_module_id: "lead-entry",
    image: ic_lead_entry_submodule,
  },
  {
    sub_module_id: "item-master",
    image: ic_item_master_submodule,
  },
];

// Define and export the function
function getAllMenuModulePathAndLogo() {
  return menu_list;
}

function getAllModuleImages() {
  return module_list;
}

function getAllSubModuleImages() {
  return sub_module_list;
}

export {
  getAllMenuModulePathAndLogo,
  getAllModuleImages,
  getAllSubModuleImages,
};
